import * as React from "react";
import SideNavigation from "@amzn/awsui-components-react/polaris/side-navigation";
import Header from "@amzn/awsui-components-react/polaris/header";
import Box from "@amzn/awsui-components-react/polaris/box";
import PageShell from "../../../../global/components/PageShell";
import ExecuteShipmentWorkflowSection from "./ExecuteShipmentWorkflowSection";

type PageType = "execute-shipment-workflow";

interface State {
    activePage: PageType;
    navOpen: boolean;
}

class Page extends React.Component<any, State> {
    constructor(props: any) {
        super(props);
        this.state = { activePage: "execute-shipment-workflow", navOpen: true };
    }

    renderContent = () => {
        switch (this.state.activePage) {
            case "execute-shipment-workflow":
                return <ExecuteShipmentWorkflowSection />;
            default:
                return (
                    <Box textAlign="center" color="text-body-secondary" padding="xxl">
                        Select an operation from the sidebar
                    </Box>
                );
        }
    };

    render() {
        return (
            <PageShell
                navigationOpen={this.state.navOpen}
                onNavigationChange={(open) => this.setState({ navOpen: open })}
                navigation={
                    <SideNavigation
                            header={{
                                text: "Shipment Operations",
                                href: "#execute-shipment-workflow",
                            }}
                            activeHref={`#${this.state.activePage}`}
                            onFollow={(e) => {
                                e.preventDefault();
                                this.setState({
                                    activePage: e.detail.href.replace("#", "") as PageType,
                                });
                            }}
                            items={[
                                {
                                    type: "section",
                                    text: "Workflows",
                                    items: [
                                        {
                                            type: "link",
                                            text: "Execute Shipment Workflow",
                                            href: "#execute-shipment-workflow",
                                        },
                                    ],
                                },
                            ]}
                    />
                }
                content={
                    <div>
                        <Box padding={{ top: "l", bottom: "l" }}>
                            <Header variant="h1">Shipment Operations</Header>
                        </Box>
                        {this.renderContent()}
                    </div>
                }
            />
        );
    }
}

export default Page;
